/**
 * This file is auto-generated from ChatInput.loc.yml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const placeholder: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Type your message...';
        case 'pl':
            return 'Wpisz wiadomość...';
    }
};

export const send: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Send';
        case 'pl':
            return 'Wyślij';
    }
};
